<template>
  <div class="component loader-component">
    <div class="sw-spinner"></div>
    <label>{{label}}</label>
  </div>
</template>

<script>
  export default {
    name: 'loader',
    props: {
      label: { default: 'Loading...' },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .loader-component {
    color: $ink;
    text-shadow: 0 0 2px #000;
    font-size: 50px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  label {
    font-size: 17px;
    vertical-align: middle;
    text-align: center;
    display: block;
    margin-top: 15px;
  }
  .sw-spinner {
    max-width: 55px;
    margin: 0 auto;
    transform: rotate(0deg);
    animation-name: rotate;
    animation-timing-function: linear;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
  }

  @keyframes rotate {
    100% { transform: rotate(-360deg); }
  }
</style>
